/* 🤖 this file was generated by svg-to-ts*/
export const icoAngular: {
  name: 'angular';
  data: string;
} = {
  name: 'angular',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.483 12.482h3.034L12 8.831l-1.517 3.651z" fill="#909090"/><path d="M12 3.074L4 6.038l.957 10.987L12 21l7.043-3.975L20 6.038l-8-2.964zm5.187 13.621H15.25l-1.045-2.606h-4.41L8.75 16.695H6.813L12 5.047l5.187 11.648z" fill="#909090"/></svg>`
};
